export type Navigration = {
  title: string
  target: string
  iconKey: string
  classNames?: string
  disabled?: boolean
}

export const menu: Navigration[] = [
  {
    title: 'Сборка',
    target: '/panel/assemble/v2',
    iconKey: 'assembling',
    classNames: 'navbar-text-extra-fill',
    disabled: true,
  },
  {
    title: 'Выдача',
    target: '/panel/issue',
    iconKey: 'issue',
    classNames: 'navbar-text-extra-fill',
    disabled: true,
  },
  {
    title: 'Приемка',
    target: '/panel/acceptance',
    iconKey: 'acceptance',
    disabled: true,
  },
  {
    title: 'Инвентаризация',
    target: '/panel/inventory',
    iconKey: 'inventory',
    classNames: 'navbar-text-extra-fill',
    disabled: true,
  },
  {
    title: 'Квитанция',
    target: '/panel/invoice',
    iconKey: 'invoice',
  },
]
